"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceTradeInPanelLegalShortPathCMS = void 0;
var DeviceTradeInPanelLegalShortPathCMS = /** @class */ (function () {
    function DeviceTradeInPanelLegalShortPathCMS() {
        this.legalText = 'Wireless Device Trade In';
        this.shortLegalLinkLabel = 'Read the AT&T Next Trade-In Terms';
    }
    return DeviceTradeInPanelLegalShortPathCMS;
}());
exports.DeviceTradeInPanelLegalShortPathCMS = DeviceTradeInPanelLegalShortPathCMS;
//# sourceMappingURL=DeviceTradeInPanelLegalShortPathCMS.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceTradeInPanel/DeviceTradeInPanelLegalShortPathCMS.cms.js
// module id = 2041
// module chunks = 8